import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';

/** An IPv4 address, or an IPv6 one (a URL keeps it in brackets). */
const isIpAddress = (host: string): boolean =>
  /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || host.startsWith('[');

/**
 * The event server's address, once the bff has answered on it; null otherwise.
 *
 * At an event, tablets and laptops open this app by the event Mac's LAN IP rather than a domain,
 * so the sign-in screen names that IP to show they reached the event server. On a domain, or
 * when the bff does not answer 200, it stays null and the screen is unchanged.
 */
export const useEventServer = (): string | null => {
  const [address, setAddress] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const url = new URL(API_ENDPOINTS.bffHealth, window.location.href);

    axios
      .get(url.href)
      .then((response) => {
        if (active && response.status === 200 && isIpAddress(url.hostname)) {
          setAddress(url.hostname);
        }
      })
      .catch(() => {
        // Not reached: nothing to show.
      });

    return () => {
      active = false;
    };
  }, []);

  return address;
};
